<div *ngIf="business" class="business-card-root">
  <div class="header" (click)="openCustomerDetailPage()">
    <div class="left-area">
      <app-rounded-image [src]="business.businessProfilePicture" xxsmall></app-rounded-image>
      <div class="text-area">
        <app-label class="name" id="business-name-business-card" isBig>{{business.businessName}}</app-label>
      </div>
    </div>
    <div class="right-area">
      <app-status
        [status]="business.status">
      </app-status>
      <app-label class="country" isBig>{{countryShortName}}</app-label>
      <span [class]="business.businessCountry | flag"></span>
    </div>
  </div>
  <div class="popup-preamble">
    <app-business-info-popup
      [ngClass]="{'visible': showInfo}"
      [activePoints]="pointSummary?.totalPoints"
      [pointsAddedThisMonth]="pointSummary?.addedOnThisMonth"
      [pointsExpiringThisMonth]="pointSummary?.expiringOnThisMonth"
      [nextPointsExpiring]="pointSummary?.nextPointsExpiring"
      [nextPointsExpiringDate]="pointSummary?.nextPointsExpiringDate"
      [pointsExpiredLastYear]="pointSummary?.expiredLastYear"
      [pointsExpiringThisYear]="pointSummary?.expiringOnThisYear"
      [pointsExpiringNextYear]="pointSummary?.expiringOnNextYear"
      [pointsRedeemedThisMonth]="pointSummary?.redeemedOnThisMonth"
      [country]="'fi fi-' + business.businessCountry.initials.toLowerCase()"
      [state]="business.businessState"
      [familyName]="selectedFamily"
      (closeClick)="closeInfo()">
    </app-business-info-popup>
  </div>
  <app-horizontal-separator></app-horizontal-separator>
  <div *ngIf="business.active" (click)="openCustomerDetailPage()">
    <div class="header">
      <div class="left-area">
        <div class="content">
          <app-label class="business-type" style="text-align: left;" isBig>{{business.businessType}}</app-label>
          <app-label class="admin-name" isBig>{{adminName}}</app-label>
          <app-label class="admin-email" isGray>{{business.businessAdminEmail}}</app-label>
        </div>
      </div>
      <div class="right-area content-right">
        <div class="content-right">
          <div *ngFor="let item of business.pointSummaryByFamily; let i = index">
            <div *ngIf="i < 3" class="summary-item">
              <div class="summary-value" >
                <app-label 
                  class="admin-series" 
                  [ngClass]="{ 'admin-series-inactive': !item.active }" isBig>
                  Series {{item.familyName}} 
                </app-label>
              </div>

              <div class="summary-value">
                <app-label class="admin-series"
                  [ngClass]="{ 'admin-series-inactive': !item.active }" isBig> {{item.vipLevel}} </app-label>
              </div>

              <div class="summary-value">
                <app-label class="admin-name"
                  [ngClass]="{ 'admin-series-inactive': !item.active }" isBig>{{ item.totalPoints  | number:'': language }} {{this.labels.points}} </app-label>
              </div>

              <div class="summary-actions">
                <app-icon-click id="business-info-click" (click)="toggleInfo($event, item.familyId!, item.familyName!)" flat>info_outline</app-icon-click>
              </div>
            </div>
            
          </div>
          <div class="show-more" *ngIf="business.pointSummaryByFamily.length > 3">
            {{ 'show-more' | transloco}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-horizontal-separator *ngIf="business.businessCreationDate"></app-horizontal-separator>
  <div *ngIf="business.businessCreationDate" class="footer">
    <app-label class="creation-date-info" isBig isGray>{{labels.createdOn}} {{business.businessCreationDate | date: 'MM.dd.YYYY'}}</app-label>
  </div>
</div>
